import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/chevron.js
const ChevronIcon = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M11.667 9.014 6.364 3.711m0 10.606 5.303-5.303"
	})
});
const ForwardRef = forwardRef(ChevronIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=chevron.js.map